function u(e, r = !1) {
  return r ? Object.keys(e).reduce((t, n) => (t[n] = void 0, t), {}) : e;
}
export {
  u as t
};
//# sourceMappingURL=toggle-rhf-rules-Z1TdwfO9.mjs.map
